/* tslint:disable */
/* eslint-disable */
/**
 * Změňte.to Admin API
 * Změňte.to Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePrefilledEmailRequestDTO
 */
export interface UpdatePrefilledEmailRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdatePrefilledEmailRequestDTO
     */
    to: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePrefilledEmailRequestDTO
     */
    cc: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePrefilledEmailRequestDTO
     */
    bcc: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePrefilledEmailRequestDTO
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePrefilledEmailRequestDTO
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePrefilledEmailRequestDTO
     */
    addMessage: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePrefilledEmailRequestDTO
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdatePrefilledEmailRequestDTO
     */
    priority?: number;
}

export function UpdatePrefilledEmailRequestDTOFromJSON(json: any): UpdatePrefilledEmailRequestDTO {
    return UpdatePrefilledEmailRequestDTOFromJSONTyped(json, false);
}

export function UpdatePrefilledEmailRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePrefilledEmailRequestDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'to': json['to'],
        'cc': json['cc'],
        'bcc': json['bcc'],
        'subject': json['subject'],
        'message': json['message'],
        'addMessage': json['add_message'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
    };
}

export function UpdatePrefilledEmailRequestDTOToJSON(value?: UpdatePrefilledEmailRequestDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'to': value.to,
        'cc': value.cc,
        'bcc': value.bcc,
        'subject': value.subject,
        'message': value.message,
        'add_message': value.addMessage,
        'name': value.name,
        'priority': value.priority,
    };
}

